import { browser, dev } from '$app/environment';
import { env } from '$env/dynamic/public';
// import { version } from '../../package.json';

export const WEBUI_BASE_URL = env.PUBLIC_WEBUI_BASE_URL || (browser ? (dev ? `http://${location.hostname}:8080` : ``) : ``);
export const WEBUI_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1`;

export const OPENAI_API_BASE_URL = `${WEBUI_BASE_URL}/openai`;
export const AUDIO_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1/audio`;
export const IMAGES_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1/images`;

export const REQUIRED_OLLAMA_VERSION = '0.1.16';

// Source: https://kit.svelte.dev/docs/modules#$env-static-public
// This feature, akin to $env/static/private, exclusively incorporates environment variables
// that are prefixed with config.kit.env.publicPrefix (usually set to PUBLIC_).
// Consequently, these variables can be securely exposed to client-side code.

export const UNAUTHENTICATED_USERS_TARGET = '/auth';
